import { render } from "./Irish.vue?vue&type=template&id=e8644efa&scoped=true"
import script from "./Irish.vue?vue&type=script&lang=js"
export * from "./Irish.vue?vue&type=script&lang=js"

import "./Irish.vue?vue&type=style&index=0&id=e8644efa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e8644efa"

export default script